<mat-form-field class="w-100">
  <mat-label>{{ title }}</mat-label>
  <input matInput [value]="value ?? 'N/A'" [disabled]="true" />
</mat-form-field>
